import { FC } from "react";

interface IProps {
  tab: string;
  setTab: (tab: string) => void;
  menu: string;
  menus: string;
  text: string;
}

const TabItem: FC<IProps> = ({
  tab,
  setTab,
  menu,
  menus,
  text,
}) => {
  return (
    <li className={(menus.includes(tab) ? ' active' : '')}>
      <a
         className="btn-item"
        onClick={() => setTab(menu)}
      >
        {text}
      </a>
    </li>    
  );
}

export default TabItem;
